<template>
    <div>
        <button-secondary @click="open">
            <template slot="icon"><i class="fa fa-pencil"></i></template> Bearbeiten
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">

                <template slot="header">
                    Raum bearbeiten
                </template>

                <div class="flex justify-end">
                    <confirm-dialog @confirmed="removeRoom">
                        <button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Raum löschen</button-delete>
                        <template slot="header">Raum löschen</template>
                        <template slot="question">Soll der Raum wirklich gelöscht werden?</template>
                        <template slot="confirm"><button-delete><template slot="icon"><i class="fa fa-trash"></i></template> Raum löschen</button-delete></template>
                    </confirm-dialog>
                </div>

                <input-text class="mb-4" v-model="item.name">
                    Raumname
                </input-text>

                <input-text class="mb-8" v-model="item.limit_persons">
                    Maximale Anzahl an Personen (Corona)
                    <template v-slot:helper>Leeres Feld: jeder Schreibtisch kann genutzt werden.</template>
                </input-text>

                <toggle-group class="mb-8" v-model.number="item.has_limit_persons_enabled">
                    Personenlimit aktiviert
                </toggle-group>

                <div class="flex justify-end">
                    <button-primary @click="update"><template slot="icon"><i class="fa fa-save"></i></template> Speichern</button-primary>
                </div>

            </modal>
        </portal>

    </div>
</template>

<script>
import InputText from "./UI/InputText";
import ButtonPrimary from "./UI/ButtonPrimary";
import ButtonWhite from "./UI/ButtonWhite";
import ConfirmDialog from "./UI/ConfirmDialog";
import ButtonSecondary from "./UI/ButtonSecondary";
import Modal from "./Modal";
import ToggleGroup from "./UI/ToggleGroup.vue";
import ButtonDelete from "./UI/ButtonDelete";

export default {
    name: "RoomEdit",

    components: {ToggleGroup, Modal, ButtonSecondary, ConfirmDialog, ButtonWhite, ButtonPrimary, InputText, ButtonDelete},

    props: ['room'],

    data: () => ({
        showModal: false,
        item: {},
        saved: false,
    }),

    methods: {
        open() {
            this.showModal = true;
            this.item = {
                id: this.room.id,
                name: this.room.name,
                limit_persons: this.room.limit_persons,
                has_limit_persons_enabled: this.room.has_limit_persons_enabled,
            };
        },
        update() {
            this.loading = true;
            axios.put('/admin/rooms/' + this.item.id, {
                name: this.item.name,
                limit_persons: this.item.limit_persons,
                has_limit_persons_enabled: this.item.has_limit_persons_enabled,
            }).then(() => {
                this.loading = false;
                this.$emit('reload');
                this.$root.$emit('alert', 'Gespeichert.');
                this.showModal = false;
                this.saved = true;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        removeRoom() {
            this.loading = true;
            window.axios.post(`/admin/rooms/${this.room.id}`, {
                _method: 'delete',
            }).then(() => {
                window.location.href = '/admin/pages/rooms';
                this.loading = false;
                this.$emit('reload');
                this.showModal = false;
                this.$router.push('/rooms');
            }).catch(error => {
                this.loading = false;
                this.$emit('reload');
                this.$root.$emit('error', error);
            })
        },
    }
}
</script>

<style scoped>

</style>
